import { render, staticRenderFns } from "./BetDialog.vue?vue&type=template&id=2cd64b2c"
import script from "./BetDialog.vue?vue&type=script&lang=js"
export * from "./BetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports